import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const CaseManagerCaseTransferAll = lazy(() => import('./CaseManagerCaseTrasferAll.jsx'))
const CaseManagerTransferSingle = lazy(() => import('./CaseManagerTransferSingle.jsx'))
const CaseManagerAcceptedSingleView = lazy(() => import('./CaseManagerAcceptedSingleView.jsx'))
const CaseManagerCaseRejectedSingleView = lazy (() => import('./CaseManagerCaseRejectedSingleView.jsx'))

const CaseManagerCaseTransferRoutes = [
    {
        path: '/CaseManagerCaseTransferAll',
        component: CaseManagerCaseTransferAll,
        auth: authRoleAccess.case_manager_case_trasfer,
    },

    {
        path: '/CaseManagerTransferSingle/:id',
        component: CaseManagerTransferSingle,
        auth: authRoleAccess.case_manager_case_trasfer,
    },

    {
        path: '/CaseManagerAcceptedSingleView/:id',
        component: CaseManagerAcceptedSingleView,
        auth: authRoleAccess.case_manager_case_trasfer,
    },

     {
        path: '/CaseManagerCaseRejectedSingleView/:id',
        component: CaseManagerCaseRejectedSingleView,
        auth: authRoleAccess.case_manager_case_trasfer,
    },

]

export default CaseManagerCaseTransferRoutes 